export default "__VITE_ASSET__DvUvo3Jr__"